export default __webpack_public_path__ + "static/media/more-info.a6327f10.svg";